import { useEffect } from 'react';
import { Control, UseFormGetValues, UseFormSetValue, UseFormWatch } from 'react-hook-form';

import { ICostForm } from 'partsOld/types';

import CostItemView from './CostItemView';

interface IProps {
  control: Control<ICostForm, object>;
  getValues: UseFormGetValues<ICostForm>;
  removeCost?: (index: number) => void;
  index: number;
  setValue: UseFormSetValue<ICostForm>;
  watch: UseFormWatch<ICostForm>;
}

const CostItem = ({ control, index, getValues, removeCost, setValue, watch }: IProps) => {
  const uom = watch('uom');
  const minQty = getValues(`costItems.${index - 1}.maxQuantity`) || 0;

  useEffect(() => {
    if (index === 0) {
      return;
    }

    setValue(`costItems.${index}.minQuantity`, minQty);
  }, [index]);

  return (
    <CostItemView
      control={control}
      index={index}
      removeCost={removeCost}
      uom={uom}
      minQty={minQty}
    />
  );
};

export default CostItem;
